export default __webpack_public_path__ + "69de28833fab96b6b9a0aae289a017bb.png";